/**
 * Created by shubham on 4/5/18.
 */

import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { APPCONFIG } from '../../config';
import { MdDialog,MdDialogRef  } from '@angular/material';
import { FormGroup, FormBuilder, FormControl, Validators, AbstractControl } from '@angular/forms';
import { HttpService } from '../../shared/services/http.service';
import { SessionHandler } from '../../shared/services/session-handler.service';
import { DialogComponent } from '../../dialog/dialog.component';
import { ActiveInactiveDialogComponent } from '../../dialog/dialog.component';


@Component({
    selector: 'wpass-details',
    template: require('./wpass.component.html')
})
export class WPASSComponent {

    dialogRef;
    WPASSForm: FormGroup;
    WPASSFormDetails: any;
    WPASSResponse = [];
    urlPattern = /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
    passwordPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;
    isChecked = false;
    isDisabled = true;

    constructor(private router: Router, private sessionHandler:SessionHandler, public httpService : HttpService, public dialog: MdDialog, private formBuilder: FormBuilder) {
        //Close Sidebar Initially
        APPCONFIG.navCollapsed = true;

        this.getWPASSDetails();
    }

    public getWPASSDetails(){
        this.httpService.getRequest('superUserOperationsApi/v1/applicationDetailsWPASS').subscribe(
            res => { this.saveWPASSDetails(res,'getAPI'); },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveUserData(){
        this.dialogRef = this.dialog.open(ActiveInactiveDialogComponent);
        this.dialogRef.componentInstance.isConfirm = true;
        this.dialogRef.componentInstance.msg = 'You are updating very sensitive information.';
        this.dialogRef.componentInstance.systemSetting = 'update_confirmation';
        this.dialogRef.afterClosed().subscribe(result => {
            if(result){
                this.httpService.postRequest(this.WPASSFormDetails,'superUserOperationsApi/v1/applicationDetailsWPASS').subscribe(
                    res => { this.saveWPASSDetails(res,'postAPI'); },
                    err => { this.httpService.onEnd(); }
                );
            }
        });
    }

    public saveWPASSDetails(res, apiStatus){
        if(res){
            if(apiStatus == 'postAPI'){
                this.httpService.onEnd();
                this.dialogRef = this.dialog.open(DialogComponent);
                this.dialogRef.componentInstance.msg = "WPASS information updated successfully.";
            }
            this.WPASSResponse = res;
            this.WPASSFormDetails = this.WPASSResponse;
            this.buildForm();
        }
        this.httpService.onEnd();
    }

    public toggle(){
        this.isChecked = !this.isChecked;
        if(this.isChecked == true){
            this.isDisabled = false;
        } else {
            this.isDisabled = true;
            this.WPASSForm.get('wpassAppUserPassword').setValue('');
            this.WPASSForm.get('wpassAppUserConfirmPassword').setValue('');
        }
        this.buildForm();
    }

    buildForm() {
        this.WPASSForm = this.formBuilder.group({
            wpassUrl: this.formBuilder.control(this.WPASSResponse['wpassUrl'], [Validators.required, Validators.pattern(this.urlPattern)]),
            wpassAppUserId: this.formBuilder.control(this.WPASSResponse['wpassAppUserId'], [Validators.required]),
            wpassAppUserPassword: this.formBuilder.control({value: '', disabled: this.isDisabled}, [Validators.required, Validators.minLength(8), Validators.maxLength(8), Validators.pattern(this.passwordPattern)]),
            wpassAppUserConfirmPassword: this.formBuilder.control({value: '', disabled: this.isDisabled}, [Validators.required]),
        },  {validator: this.checkPasswords});
        this.WPASSForm.valueChanges.subscribe(data => {
            this.WPASSFormDetails = this.WPASSForm.getRawValue();
            this.WPASSFormDetails['id'] = this.WPASSResponse['id'];
            this.WPASSFormDetails.validate = this.WPASSForm.valid;
        });
    }

    checkPasswords(group: FormGroup) {
        if(group.get('wpassAppUserPassword').value === group.get('wpassAppUserConfirmPassword').value){
            group.get('wpassAppUserConfirmPassword').setErrors(null);
            return null;
        } else{
            group.get('wpassAppUserConfirmPassword').setErrors({'incorrect': true});
            return {'mismatch': true};
        }
    }

    ngOnInit() {
        this.buildForm();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/wpass/wpass.component.ts